import {createApiResource} from 'data/utils';

const resource = createApiResource({
	name: 'team',
	pathName: '/teams',
	defaultIncludes: ['users', 'organization'],
});

export const useTeams = resource.createUseQueryIndex({
	defaultParams: {
		_limit: 999,
		getAllTeams: true,
		customerOrganizationTeams: false,
	},
});
export const useTeam = resource.createUseQueryById();
export const useCreateTeam = resource.createUseMutationCreate();
export const useUpdateTeam = resource.createUseMutationUpdate();
export const useDeleteTeam = resource.createUseMutationDelete();
